<template>
	<div class="system-msg-body">
        <div class="fx-header">
			<p>系统消息</p>
		</div>
		<div>
			<div class="tr-message">
				<div class="tr-title">系统消息</div>
				<div class="unread">{{count}} 条未读消息 <span @click="cleanMessage" :class="count === 0 ? 'disabled' : ''">全部已读</span></div>
			</div>
		</div>
		<div class="msg-list">
			<ul v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false" infinite-scroll-immediate-check="false">
				<li class="msg-wrapper" v-for="item in msgList" :key="item.id" @click="goDetail(item)">
					<span class="dot" v-if="item.readflag === 0"></span>
					<p class="first-tit">{{item.message_alert}}</p>
					<p class="forth-time">推送时间：{{item.modifydate}}</p>
				</li>
			</ul>
			<p v-if="loading">加载中...</p>
			<!-- <p v-if="noMore" class="nonono">没有更多了</p> -->
		</div>
		<el-dialog :title="'系统通知'" :before-close="cancelMsgDialog" class="dialog-title notice" :visible.sync="showMsgDialog" width='600px' height='300px' :close-on-click-modal="false">
			<div class="msg-info">
				{{message}}
			</div>
			<el-button type="primary" size="medium" @click="haveRead" style="margin-top: 20px;">确认已读</el-button>
		</el-dialog>
	</div>
</template>
<script>

export default {
	name: 'systemMsg',
	data () {
		return {
			shopOptions: [],
			sellerShopId: '',
			msgList: [],
			count: 0,
			start: 0,
			total: 0,
			loading: false,
			orderParams: {},
			showMsgDialog: false,
			message: '',
			readMsgId: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '12-2')
		this.findShopList().then((data) => {
			if (data.length > 0) {
				this.shopOptions = data
				if (window.sessionStorage.getItem('organid')) {
					this.sellerShopId = window.sessionStorage.getItem('organid')
				} else {
					this.sellerShopId = data[0].organid
					window.sessionStorage.setItem('organid', this.sellerShopId)
				}
				this.getMessage()
			}
		})
	},
	computed: {
		noMore () {
			return this.total === 1
		},
		disabled () {
			return this.loading || this.noMore
		}
	},
	methods: {
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		load () {
			this.loading = true
			setTimeout(() => {
				this.start += 15
				this.getMessage()
			}, 1000)
		},
		getMessage () {
			let params = {
				bsflag: 1,
				msgtype: 4,
				start: this.start,
				length: 15
			}
			this.$store.dispatch('requestPost', {
				// api: 'urlFS',
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.count = res.data.bussinessCount.count
					res.data.bussinessMessage.forEach(element => {
						element.msg = element.message_alert
						this.msgList.push(element)
					})
					if (res.data.bussinessMessage.length < 15) {
						this.total = 1
					}
					this.loading = false
				}
			})
		},
		cleanMessage () {
			let params = {
				bsflag: 1,
				msgtype: 4,
				organid: this.sellerShopId
			}
			this.$store.dispatch('requestPost', {
				// api: 'urlFS',
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/allmessageunreadflag/update`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.loading = false
					this.start = 0
					this.total = 0
					this.msgList = []
					// this.$router.go(0)
					location.reload()
				}
			})
		},
		goDetail (item) {
			this.message = item.msg
			this.readMsgId = item.message_id
			this.showMsgDialog = true
		},
		cancelMsgDialog () {
			this.showMsgDialog = false
		},
		haveRead () {
			let params = {
				id: this.readMsgId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/unread/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.loading = false
					this.start = 0
					this.total = 0
					this.msgList = []
					// this.$router.go(0)
					location.reload()
				}
			})
			this.showMsgDialog = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.system-msg-body {
	flex: 1
	display flex
	flex-direction column
	padding 16px 0 0 30px;
	box-sizing border-box
	color : #484848
	.shop-position {
		display flex
		align-items: center
		height: 60px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.tr-message {
		// float: left
		text-align: left
		margin : 20px 0 5px 20px
		.tr-title {
			font-size : 16px
			font-weight : bold
			// display : inline-block
			border-left : 4px solid var(--fx-primary-color)
			padding-bottom : 2px
			text-indent: 10px
		}
	}
	.unread{
		// float: left
		margin-left : 15px
		font-size : 14px
		height: 30px
		// margin-bottom : 12px
		margin-top: 8px
		span{
			cursor: pointer
			color : var(--fx-primary-color)
		}
		img{
			display: inline
			vertical-align : middle
			cursor : pointer
			margin : -2px 0 0 12px
		}
	}
	.msg-list{
		// max-height : 500px
		clear: left
		// margin-top : 10px
		margin-bottom : 10px
		height : 100%
		overflow: auto
		&::-webkit-scrollbar {/*滚动条整体样式*/
            width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 10px;
            scrollbar-arrow-color: red;
        }
        &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.05);
            background: rgba(0,0,0,0.2);
            scrollbar-arrow-color: red;
        }
        &::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.05);
            border-radius: 4px;
            background: rgba(0,0,0,.05);
        }
	}
	.msg-info {
		width: 85%
		padding-bottom: 35px;
		line-height: 28px
    margin: 0 auto
    text-align: left
	}
	.msg-wrapper{
		display: flex
		// width : 850px
		text-align: left
		height : 50px
		line-height : 50px
		background-color : #F6FAFF
		border-radius : 10px
		margin-bottom : 12px
		// padding : 16px 24px
		padding-left : 24px
		box-sizing : border-box
		position: relative
		cursor : pointer
		justify-content: space-between;
		.first-tit{
			font-weight : bold
			font-size : 14px
			margin-bottom : 10px
			width : 80%
			overflow: hidden
			text-overflow:ellipsis
			white-space: nowrap
		}
		.second-con{
			font-size : 14px
			margin-bottom : 20px
			width : 20%
			text-align : center
			&.mg10{
				margin-bottom: 10px
			}
		}
		.third-no{
			font-size : 13px
			color : #797979
			margin-bottom : 10px
			width : 35%
			text-align : right
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			&.mg5{
				margin-bottom : 5px
			}
		}
		.forth-time{
			font-size : 13px
			color : #797979
			width : 20%
			text-align : center
		}
		.dot{
			position : absolute
			width : 8px
			height : 8px
			border-radius : 50%
			background-color : #fa0601
			top: 12px
			left : 12px
		}
		.look-msg{
			position : absolute
			right : 24px
			bottom : 15px
			color : #5c995e
			font-size : 12px
			text-decoration : underline
		}
	}
	.nonono {
		text-align: center
		margin-bottom: 10px
	}
	.disabled {
		color: #999 !important
		pointer-events: none
	}
}
/deep/ .el-dialog {
	text-align: center
}
</style>
<style lang="stylus">
.notice .el-dialog__title {
	padding-left 0
	border-left none
	font-weight bold
}
</style>

